import { action, makeObservable, observable } from 'mobx';

interface IRulePublishHistory {
    id: string;
    author: string;
    createdOn?: string;
    publishHistoryManifest: string;
}

export default class RulePublishHistoryStore {
    rulePublishHistory: IRulePublishHistory = {
        id: '',
        author: '',
        publishHistoryManifest: ''
    };

    constructor(rulePublishHistory: IRulePublishHistory & { author: { email: string } }) {
        this.update(rulePublishHistory);

        makeObservable(this, {
            update: action,
            rulePublishHistory: observable
        });
    }

    update(rulePublishHistory: IRulePublishHistory & { author: { email: string } }): void {
        this.rulePublishHistory = {
            ...this.rulePublishHistory,
            ...rulePublishHistory,
            author: rulePublishHistory.author?.email ? rulePublishHistory.author.email : 'Infocyte'
        };
    }
}
